import { GDSButtonProps } from '@leagueplatform/genesis-core';

export type Indicator =
  | 'NEW_TAB_INTERNAL'
  | 'NEW_WINDOW_INTERNAL'
  | 'EXTERNAL_LINK'
  | undefined;

interface IconTokenByStringProps {
  [key: string]: string;
}

const IconTokenByString: IconTokenByStringProps = {
  NEW_TAB_INTERNAL: 'newTabInternal',
  NEW_WINDOW_INTERNAL: 'newWindowInternal',
  EXTERNAL_LINK: 'externalLink',
};

export const getIconToken = (indicatorString: Indicator) =>
  IconTokenByString[indicatorString!] as GDSButtonProps<'button'>['indicator'];
